import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/home.css";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import SEO from "../components/SEO";

import glasses from "../images/hero-landscape.jpg";
import boss from "../images/boss.jpg";
import gucci from "../images/gucci.jpg";
import lacoste from "../images/lacoste.jpg";
import MJ from "../images/MJ.jpg";
import rayban from "../images/rayban.jpg";
import versace from "../images/versace.jpg";
import raybanB from "../images/raybanB.png";
import versaceB from "../images/versaceB.png";
import gucciB from "../images/gucciB.png";
import pradaB from "../images/pradaB.png";

const Home = () => {
  const navigate = useNavigate();

  // 🔥 RENAMED PRODUCTS (NO BRAND NAMES)
  const products = [
    { id: 1, name: "M&L Midnight Black", image: versace },
    { id: 2, name: "M&L Classic Silver", image: rayban },
    { id: 3, name: "M&L Shadow Edition", image: gucci },
    { id: 4, name: "M&L Titan Frame", image: boss },
    { id: 5, name: "M&L Urban Style", image: MJ },
    { id: 6, name: "M&L Sport Flex", image: lacoste },
  ];

  

  return (
    
    <>
  <SEO 
    title="Mark & Luth - Premium Sunglasses in India"
    description="Shop stylish and affordable sunglasses in India. UV protection, modern designs, and premium quality."
  />

    <div className="home dark-theme">
      <Navbar />

      {/* 🔥 HERO */}
      <section className="hero">
        <img src={glasses} className="hero-bg" alt="hero" />
        <div className="hero-overlay" />

        <div className="hero-content">
          <h1>Luxury Style. Without the Luxury Price.</h1>
          
          <p>Mark & Luth — Premium Eyewear for Modern Lifestyle</p>

          <div className="hero-buttons">
            <button onClick={() => navigate("/shop")}>
              Shop Collection
            </button>

            <button
              className="view-btn"
              onClick={() => {
                document
                  .getElementById("collections")
                  .scrollIntoView({ behavior: "smooth" });
              }}
            >
              Explore Collections
            </button>
          </div>

          {/* TRUST BADGES */}
          <div className="trust-row">
            <span>✔ Secure Payment</span>
            <span>✔ Premium Quality</span>
            <span>✔ Fast Dispatch</span>
          </div>
        </div>
      </section>

      {/* 🔥 COLLECTION SECTION (REPLACED BRANDS) */}
      <section className="categories" id="collections">
        <h2>Shop By Collections</h2>

        <div className="category-row">
          <div
            className="category-card"
            onClick={() => navigate("/shop?collection=classic")}
          >
            <img src={raybanB} alt="Classic Collection" />
            <p>Classic Collection</p>
          </div>

          <div
            className="category-card"
            onClick={() => navigate("/shop?collection=luxury")}
          >
            <img src={versaceB} alt="Luxury Collection" />
            <p>Luxury Collection</p>
          </div>

          <div
            className="category-card"
            onClick={() => navigate("/shop?collection=urban")}
          >
            <img src={gucciB} alt="Urban Collection" />
            <p>Urban Collection</p>
          </div>

          <div
            className="category-card"
            onClick={() => navigate("/shop?collection=limited")}
          >
            <img src={pradaB} alt="Limited Edition" />
            <p>Limited Edition</p>
          </div>
        </div>
      </section>

      {/* 🔥 TRENDING */}
      <section className="products-section">
        <h2>Trending Now</h2>

        <div className="products-grid">
          {products.map((product) => (
            <div
              key={product.id}
              className="product-card simple"
              onClick={() => navigate(`/shop?product=${product.name}`)}
            >
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>

              <h3>{product.name}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* 🔥 WHY US */}
      <section className="why-us">
        <h2>Why Choose Mark & Luth</h2>

        <div className="why-grid">
          <div>
            <h3>Premium Quality</h3>
            <p>Carefully selected materials for durability and comfort.</p>
          </div>

          <div>
            <h3>Modern Designs</h3>
            <p>Inspired by global luxury trends, crafted for everyday wear.</p>
          </div>

          <div>
            <h3>Affordable Luxury</h3>
            <p>High-end style without the premium price tag.</p>
          </div>
        </div>
      </section>

      {/* 🔥 BRAND STORY */}
      <section className="why-us">
        <h2>About Mark & Luth</h2>

        <div className="why-grid">
          <div>
            <p>
              Mark & Luth was created to bring premium eyewear designs to everyone.
              We focus on style, comfort, and confidence — without making it expensive.
            </p>
          </div>
        </div>
      </section>

      {/* 🔥 OFFER */}
      <section className="promo">
        <div className="promo-box">
          <h2>Flat 40% OFF</h2>
          <p>Limited Time Offer</p>
          <button onClick={() => navigate("/shop")}>
            Grab Now
          </button>
        </div>
      </section>

      {/* 🔥 FOOTER */}
      <footer className="footer">
        <div>
          <h3>Mark & Luth</h3>
          <h1>Premium Sunglasses for Men & Women in India</h1>
          <p>Premium eyewear for everyday confidence.</p>
        </div>

        <div>
          <h3>Quick Links</h3>
          <p><Link to="/contact">Contact</Link></p>
          <p><Link to="/returns">Returns</Link></p>
          <p><Link to="/shipping">Shipping</Link></p>
          <p><Link to="/privacy-policy">Privacy Policy</Link></p>
        </div>

        <div>
          <h3>Follow Us</h3>
          <p>
            <a href="https://www.instagram.com/markandluth/" target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
          </p>
          <p>
            <a href="https://www.facebook.com/profile.php?id=61579540435854" target="_blank" rel="noopener noreferrer">
              Facebook
            </a>
          </p>
        </div>
      </footer>

           <BottomNav />
    </div>
  </>
  );
};

export default Home;